import React, {Component} from 'react'
import './style.css'
import NRTAvatar from "../../../../components/_common/Avatar"
import NRTFormStateManager from "../../../../components/_common/_form/FormStateManager"
import NRTHorizontalStack from "../../../../components/_common/_containers/HorizontalStack"
import NRTFormInput from "../../../../components/_common/_form/FormInput"
import NRTButton from "../../../../components/_common/_buttons/Button"
import {Validators} from "../../../../components/_common/_form/Validators"
import MCLoadingOverlay from "../../../../components/_minha-central/LoadingOverlay"
import MCEadTitle from "../../../../components/_ead/Title"
import NRTTabContainer from "../../../../components/_common/TabContainer";
import PersonRequests from "../../../../requests/person-requests"
import _ from 'lodash'

const SIMULATE_SAVE_EAD_USER_ERROR = false


const md5 = require('md5')

class NRTEadProfilePage extends Component {


    state = {
        activeTabId: 'info',
        loading: false,
        formPassword: {}
    }

    onFormChange = (form) => {
        this.setState({form})
    }

    passwordFormChanged = (form) => {
        this.setState({formPassword: form})
    }


    componentWillReceiveProps(nextProps) {
        this.setState({
            activeTabId: nextProps.match.params.page || this.state.activeTabId
        })
    }


    tabClicked = (tabId) => {

        this.props.history.push('/conta/perfil/' + tabId)
    }


    onError(errorMsg) {

        this.props.context.set({
            toastMessage: {
                type: 'error',
                content: errorMsg
            }
        })
    }


    onSuccess(successMsg) {

        this.props.context.set({
            toastMessage: {
                type: 'success',
                content: successMsg
            }
        })
    }


    onPasswordFormSubmit = () => {

        const {formPassword} = this.state
        const {person} = this.props.context

        if (!formPassword.dirty)
            return console.log('form n sendo submetido')


        this.formPasswordInstance.validate(() => {
            if (!formPassword.valid)
                return console.log('form n sendo submetido')


            const passwordMd5 = person.password
            const currentPassword = formPassword.values.currentPassword

            if (passwordMd5 !== md5(currentPassword))
                return this.onError('A senha atual está incorreta!')


            this.savePerson({
                ...this.props.context.person,
                password: md5(formPassword.values.newPassword)
            }, 'passwordData')


        })


    }


    onProfileFormSubmit = _.debounce(() => {


        const {form} = this.state

        if (!form.dirty)
            return console.log('form n sendo submetido')

        this.formProfile.validate(() => {
            if (!form.valid)
                return console.log('form n sendo submetido')

            this.savePerson({
                ...this.props.context.person,
                ...form.values
            }, 'valuesData')


        })


    }, 300)


    confirmPasswordValidate = () => {

        return value => {
            if (_.get(this.state.formPassword, 'values.newPassword', null) === value) return null

            return 'Senhas não conferem.'
        }
    }


    savePerson(personDto, typeData) {

        this.setState({
            loading: true
        })

        const req = SIMULATE_SAVE_EAD_USER_ERROR ?
            Promise.reject('Erro simulado SIMULATE_SEARCH_EAD_USER_ERROR') :
            PersonRequests.save(personDto)

        req
            .then((result) => {
                this.setState({
                    loading: false
                })
                if (_.get(result, 'success', false))
                    typeData == 'valuesData' ? this.onSuccess('Seus dados foram atualizados com sucesso!') : this.onSuccess('Senha alterada com sucesso!')
                this.props.context.set({
                    person: personDto,
                })

            })
            .catch(err => {
                console.error(err)
                this.onError('Error ao atualizar os dados do perfil')
            })
    }


    render() {
        const {
            history,
            match,
        } = this.props

        const {
            person
        } = this.props.context

        const {
            name,
            email,
            currentPassword,
            newPassword,
            phoneOne,
            mainImageUrl
        } = person

        const changingPassword = match.params.page === 'changepassword'


        return (


            <div className="nrt-ead-profile-page">
                <MCEadTitle title={'Meu Perfil'}/>

                <NRTTabContainer activeTabId={this.state.activeTabId}
                                 handleTabChange={false}
                                 onTabClick={this.tabClicked}

                                 tabs={[
                                     {
                                         id: 'info',
                                         label: 'Meus dados',

                                         content: (
                                             <div className="profile-container">
                                                {this.state.loading && <MCLoadingOverlay show={true} />}
                                                 <div className="left-column">
                                                     {mainImageUrl ? <NRTAvatar imgSource={mainImageUrl} rounded/> :
                                                         <NRTAvatar rounded/>}
                                                     <h4>{name || 'Ricardo'}</h4>
                                                 </div>
                                                 <div className="content-column">
                                                     <NRTFormStateManager onStateChange={this.onFormChange}
                                                                          ref={f => this.formProfile = f}

                                                     >
                                                         <NRTHorizontalStack fractions={[1]}
                                                                             >
                                                             <NRTFormInput label={'Nome'}
                                                                           name={'name'}
                                                                           value={name}
                                                                           validators={[
                                                                               Validators.required(),
                                                                           ]}
                                                                           disabled={true}/>

                                                             <NRTFormInput label={'E-mail'}
                                                                           name={'email'}
                                                                           validators={[
                                                                               Validators.required(),
                                                                               Validators.email(),
                                                                           ]}
                                                                           value={email}
                                                                           disabled={true} />

                                                             <NRTFormInput name={'phoneOne'}
                                                                           ref={'phoneOneInput'}
                                                                           label={'Telefone'}
                                                                           validators={[
                                                                               Validators.required(),
                                                                               Validators.phone(),
                                                                           ]}
                                                                           value={phoneOne || ''}
                                                                           type={'phone'}
                                                                           disabled={true} />

                                                             {/* <NRTButton loading={this.state.loading && true} style={{background: 'var(--primary-color)'}}
                                                                        onClick={this.onProfileFormSubmit}>
                                                                 Salvar
                                                             </NRTButton> */}

                                                         </NRTHorizontalStack>

                                                     </NRTFormStateManager>
                                                 </div>
                                             </div>
                                         )
                                     },
                                     {
                                         id: 'changepassword',
                                         label: 'Alterar Senha',

                                         content: (
                                             <div className="profile-container">
                                                {this.state.loading && <MCLoadingOverlay show={true} />}
                                                 <div className="left-column">
                                                     {mainImageUrl ? <NRTAvatar imgSource={mainImageUrl} rounded/> :
                                                         <NRTAvatar rounded/>}
                                                     <h4>{name || 'Ricardo'}</h4>
                                                 </div>
                                                 <div className="content-column">


                                                     <NRTFormStateManager onStateChange={this.passwordFormChanged}
                                                                          ref={cmp => this.formPasswordInstance = cmp}>

                                                         <NRTHorizontalStack fractions={[1]}
                                                                             >
                                                             <NRTFormInput label={'Senha Atual'}
                                                                           name={'currentPassword'}
                                                                           value={currentPassword}
                                                                           customProps={{
                                                                               type: 'password'
                                                                           }}
                                                                           validators={[
                                                                               Validators.required()
                                                                           ]}
                                                             />

                                                             <NRTFormInput label={'Nova Senha'}
                                                                           name={'newPassword'}
                                                                           value={newPassword}
                                                                           customProps={{
                                                                               type: 'password'
                                                                           }}
                                                                           validators={[
                                                                               Validators.required()
                                                                           ]}
                                                             />

                                                             <NRTFormInput label={'Confirmar nova senha'}
                                                                           name={'confirmPassword'}
                                                                           value={newPassword}
                                                                           customProps={{
                                                                               type: 'password'
                                                                           }}

                                                                           validators={[
                                                                               Validators.required(),
                                                                               this.confirmPasswordValidate()
                                                                           ]}
                                                             />

                                                             <NRTButton loading={this.state.loading && true} style={{background: 'var(--primary-color)'}}
                                                                        onClick={this.onPasswordFormSubmit}>
                                                                 Alterar Senha
                                                             </NRTButton>

                                                         </NRTHorizontalStack>

                                                     </NRTFormStateManager>
                                                 </div>
                                             </div>
                                         )
                                     }
                                 ]}
                />


            </div>
        )
    }
}


NRTEadProfilePage.propTypes = {}

NRTEadProfilePage.defaultProps = {}


export default NRTEadProfilePage;




// WEBPACK FOOTER //
// ./src/_pages/Account/_pages/Profile/index.js